import { Injectable } from '@angular/core';
import { BreadcrumbsIconsEnum, UIIconsEnum } from '../enums/icons.enum';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  constructor() { }

  getBreadcrumbsIconByName(name: keyof typeof BreadcrumbsIconsEnum):BreadcrumbsIconsEnum {
    return BreadcrumbsIconsEnum[name];
  }

  getUIIconByName(name: keyof typeof UIIconsEnum):UIIconsEnum {
    return UIIconsEnum[name];
  }
}
